import { memo } from 'react';
import { IconButton } from 'src/components';

const ShareButton = (props: any) => {
    const { title, url } = props;

    const handleClick = () => {
        if (navigator.share) {
            navigator.share({
                title: title,
                url: url,
            });
            return;
        }
    };

    return (
        <IconButton
            classNameIcon="text-[24px] text-black"
            className="p-[6px]"
            icon="new-shareall-light"
            onClick={handleClick}
        />
    );
};

export default memo(ShareButton);
